import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';

// This is not a real property, the lists-backend team added this to the
// ILS schema to allow filtering on when an event occurred
export const occurredAtFieldName = 'hs_occurred_at_for_filter_evaluation';
export const getUnifiedEventOccurredAt = () => DSFieldRecord({
  label: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.UNIFIED_EVENTS.hs_occurred_at_for_filter_evaluation.label'),
  description: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.UNIFIED_EVENTS.hs_occurred_at_for_filter_evaluation.description'),
  name: occurredAtFieldName,
  type: DATE_TIME
});